export function ResizeObserver(...args) {
  return window?.ResizeObserver ? new window.ResizeObserver(...args)
    : { observe() {}, unobserve() {}, disconnect() {} };
}
